import React from 'react';
import { Button, CircularProgress } from '@mui/material';
import Typography from '@mui/material/Typography';

type Props = {
    title: string;
    onClick: any;
    onBlur?: any;
    startIcon: JSX.Element | string;
    sx?: any;
    disabled?: false | boolean;
    loading?: boolean;
    id?: string;
};

function ButtonGeneral({
    title,
    onClick,
    onBlur,
    startIcon,
    sx,
    disabled,
    loading,
    id,
}: Props) {
    return (
        <Button
            id={id}
            variant="contained"
            startIcon={
                loading ? (
                    <CircularProgress size={20} color="inherit" />
                ) : startIcon !== '' ? (
                    startIcon
                ) : null
            }
            onClick={onClick}
            onBlur={onBlur}
            style={{ backgroundColor: disabled ? '#696969' : '' }}
            disabled={disabled || loading}
            sx={sx}
        >
            <Typography
                color="secondary"
                component="div"
                sx={{ flexGrow: 1, fontSize: { lg: 12, md: 10.5, xs: 9 } }}
            >
                {title}
            </Typography>
        </Button>
    );
}

export default ButtonGeneral;
